import React from "react"
const LandingFiller = props => {
  return (
    <>
      <div className="root container responsivegrid" id="main-content">
        <div id="container-181c79087e" className="cmp-container">
          <div className="container responsivegrid">
            <div id="container-9241f43c45" className="cmp-container">
              <div className="kf-react-container cart-landing">
                <div className="row no-gutters cart-landing__header">
                  <div className="col-8">
                    <p className="shimmer-loading__para shimmer"></p>
                  </div>
                  <div className="col-4">
                    <div className="cart-landing__support d-none d-lg-block">
                      <p className="shimmer-loading__para shimmer"></p>
                    </div>
                  </div>
                </div>
                <div className="row no-gutters">
                  <div className="col-lg-8">
                    <div className="cart-landing__content">
                      <div className="row no-gutters cart-items">
                        <div className="col">
                          <div className="row no-gutters">
                            <div className="col-lg-6">
                              <span className="shimmer-loading__title shimmer"></span>
                            </div>
                            <div className="col-lg-6"></div>
                          </div>
                          <div className="row no-gutters">
                            <div className="col-12">
                              <div className="order-summary">
                                <p className="shimmer-loading__para shimmer"></p>
                              </div>
                            </div>
                          </div>
                          <div className="row cart-items__th--mobile no-gutters">
                            <div className="col-7 cart-items__td--mobile">
                              <p className="shimmer-loading__para shimmer"></p>
                            </div>
                            <div className="col-5"></div>
                          </div>
                          <div className="row cart-items__th no-gutters">
                            <div className="col-7 ">
                              <div className="cart-items__td d-none d-lg-block">
                                <p className="shimmer-loading__para shimmer"></p>
                              </div>
                            </div>
                            <div className="col-5"></div>
                          </div>
                          <div className="cart-items__no-items">
                            <div className="cart-items__no-items-message">
                              <span className="shimmer-loading__title-h3 shimmer"></span>
                            </div>
                            <section className="cart-items__no-items-links">
                              <p className="shimmer-loading__para shimmer"></p>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="row">
                      <div className="col-12">
                        <div className="order-summary">
                          <p className="shimmer-loading__button shimmer"></p>

                          <div className="order-summary__title">
                            <span className="shimmer-loading__title-h3 shimmer"></span>
                          </div>
                          <div className="order-summary__item">
                            <p className="shimmer-loading__para shimmer width-full"></p>
                          </div>
                          <hr className="order-summary__separator" />
                          <div className="order-summary__item">
                            <p className="shimmer-loading__para shimmer width-full"></p>
                          </div>
                          <div className="order-summary__input-group">
                            <p className="shimmer-loading__para shimmer width-full"></p>
                            <hr className="order-summary__separator" />
                            <div className="order-summary__item">
                              <p className="shimmer-loading__para shimmer width-full"></p>
                            </div>
                            <hr className="order-summary__separator" />
                            <div className="order-summary__item ">
                              <p className="shimmer-loading__para shimmer width-full"></p>
                            </div>
                            <div className="order-summary__zip-label">
                              <p className="shimmer-loading__para shimmer"></p>
                            </div>
                            <hr className="order-summary__separator" />
                            <div className="order-summary__item">
                              <p className="shimmer-loading__para shimmer width-full"></p>
                            </div>
                          </div>
                          <div className="download-specs d-none d-lg-block">
                            <p className="shimmer-loading__para shimmer"></p>
                            <p className="shimmer-loading__para shimmer"></p>
                            <p className="shimmer-loading__para shimmer"></p>

                            <div className="download-specs__cta">
                              <span>
                                <p className="shimmer-loading__para shimmer"></p>
                              </span>
                              <span>
                                <p className="shimmer-loading__para shimmer"></p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row cart-info  width-full">
                        <div className="col-12 cart-info__support">
                          <p className="shimmer-loading__para shimmer width-full"></p>
                        </div>
                        <div className="col-12">
                          <span className="shimmer-loading__title-h4 shimmer"></span>

                          <p className="shimmer-loading__para shimmer"></p>
                          <p className="shimmer-loading__para shimmer"></p>
                          <p className="shimmer-loading__para shimmer"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LandingFiller
